<template>
  <path
    d="M12 5.00018V13.5502C11.06 13.0102 9.9 12.8002 8.67 13.2302C7.33 13.7102 6.3 14.9002 6.06 16.3002C5.6 19.0402 7.92 21.3802 10.65 20.9502C12.61 20.6402 14 18.8402 14 16.8502V7.00018H16C17.1 7.00018 18 6.10018 18 5.00018C18 3.90018 17.1 3.00018 16 3.00018H14C12.9 3.00018 12 3.90018 12 5.00018Z"
  />
</template>
